import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, Grid2, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import classnames from "classnames";
import DatePickerRange from "components/common/DatePickerRange";
import log from "loglevel";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { API_URL } from "services";
import Select from "../common/Select";
import { actions } from "./logic/formActions";
import { styles } from "./styles";

import { AccordionSummary } from "@mui/material";
import "./styles.css";
import {DATE_FORMAT_SHORT, formatDate} from "components/common/dateUtils";

class AdvertisementInformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focusedInputDateIncident: null,
            assocLocation: "",
            assocComments: "",
        };
    }

    componentDidMount() {
        this.props.getAssociationTypes(API_URL.advertisingAT());
    }

    componentDidUpdate() {
        if (this.props.searchFormCleared && (this.state.assocComments || this.state.assocLocation)) {
            this.setState({
                assocLocation: "",
                assocComments: "",
            });
        }
    }

    checkDate = (e, start, end) => {
        log.debug("date", e.target.value, e.target.value === "");
        if (e.target.name.endsWith("Start")) {
            if (e.target.value === "") {
                e.target.value = formatDate(new Date(1900, 0), DATE_FORMAT_SHORT);
                log.debug(e.target.value);
            }
            if (end < e.target.value) {
                const fieldName = e.target.name.replace("Start", "End");
                this.props.onChange({
                    target: {
                        name: fieldName,
                        value: e.target.value,
                    },
                });
            }
        }
        if (e.target.name.endsWith("End")) {
            if (e.target.value === "") {
                e.target.value = formatDate(new Date(3000, 0), DATE_FORMAT_SHORT);
                log.debug(e.target.value);
            }
            if (start > e.target.value) {
                const fieldName = e.target.name.replace("End", "Start");
                this.props.onChange({
                    target: {
                        name: fieldName,
                        value: e.target.value,
                    },
                });
            }
        }
        this.props.onChange(e);
    };

    checkTime = (e, start, end) => {
        if (e.target.name.endsWith("Start")) {
            if (e.target.value && end < e.target.value) {
                const fieldName = e.target.name.replace("Start", "End");
                this.props.onChange({
                    target: {
                        name: fieldName,
                        value: e.target.value,
                    },
                });
            }
        }
        if (e.target.name.endsWith("End")) {
            if (e.target.value && start > e.target.value) {
                const fieldName = e.target.name.replace("End", "Start");
                this.props.onChange({
                    target: {
                        name: fieldName,
                        value: e.target.value,
                    },
                });
            }
        }
        this.props.onChange(e);
    };

    handleInputChange = (e) => {
        e.persist();
        if (e.keyCode !== 13 && e.target.value !== "") {
            this.setState({
                [e.target.name]: e.target.value,
            });
        } else {
            this.props.onChange(e);
            if (e.target.value === "")
                this.setState({
                    [e.target.name]: e.target.value,
                });
        }
    };

    render() {
        const {
            classes,
            onChange,
            assocType,

            assocInciDateStart,
            assocInciDateEnd,
            assocInciTimeStart,
            assocInciTimeEnd,
            associationTypes,
        } = this.props;

        const assocTypes = associationTypes.map((type) => ({ value: type.id, label: type.name }));

        return (
            (<Grid2 container >
                <Accordion className={classes.root}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                        <Typography>Association Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <Grid2 container spacing={2}>
                            <Grid2 container  className={classnames(classes.item, classes.selectWrapper)} size={12}>
                                <Select
                                    placeholder="All Association Types"
                                    value={assocType}
                                    defaultMenuPortalTarget
                                    onChange={(e) => onChange({ target: { value: e, name: "assocType" } })}
                                    options={assocTypes}
                                />
                            </Grid2>
                            <Grid2 container padding={1} size={12}>
                                <TextField
                                    id="outlined-basic"
                                    className={classes.formControl}
                                    label="All Locations"
                                    margin="normal"
                                    variant="outlined"
                                    name="assocLocation"
                                    value={this.state.assocLocation}
                                    onChange={this.handleInputChange}
                                    onKeyUp={this.handleInputChange}
                                />
                            </Grid2>
                            <Grid2 container padding={1} size={12}>
                                <TextField
                                    id="outlined-basic"
                                    className={classes.formControl}
                                    label="All Comments"
                                    margin="normal"
                                    variant="outlined"
                                    name="assocComments"
                                    value={this.state.assocComments}
                                    onChange={this.handleInputChange}
                                    onKeyUp={this.handleInputChange}
                                />
                            </Grid2>
                            {}
                            {}

                            <Grid2 container padding={2} className="last-date" size={12}>
                                <DatePickerRange
                                    dateName="Incident"
                                    fieldName="assocInciDate"
                                    start={assocInciDateStart}
                                    end={assocInciDateEnd}
                                    onChange={(field) =>
                                        onChange({
                                            target: {
                                                name: Object.entries(field)[0][0],
                                                value: Object.entries(field)[0][1],
                                            },
                                        })
                                    }
                                    startSuffix="Start"
                                    endSuffix="End"
                                />
                            </Grid2>
                            <Grid2 container padding={1} size={12}>
                                <Grid2 container className={classes.date} justify={"flex-start"} size={{
                                    md: 6
                                }}>
                                    <TextField
                                        id="date1"
                                        data-testid="date1"
                                        label="Incident Time"
                                        type="time"
                                        variant="outlined"
                                        name={"assocInciTimeStart"}
                                        value={assocInciTimeStart}
                                        onChange={(e) => this.checkTime(e, assocInciTimeStart, assocInciTimeEnd)}
                                        fullWidth
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}
                                    />
                                </Grid2>
                                <Grid2 container  className={classes.date} justify={"flex-end"} size={{
                                    md: 6
                                }}>
                                    <TextField
                                        id="date2"
                                        data-testid="date2"
                                        label="Incident Time"
                                        type="time"
                                        variant="outlined"
                                        name={"assocInciTimeEnd"}
                                        value={assocInciTimeEnd}
                                        onChange={(e) => this.checkTime(e, assocInciTimeStart, assocInciTimeEnd)}
                                        fullWidth
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
                            {}
                        </Grid2>
                    </AccordionDetails>
                </Accordion>
            </Grid2>)
        );
    }
}

const localStyles = (theme) => {
    const globalStyles = styles(theme);

    return {
        ...globalStyles,
        root: {
            width: "100%",
        },
        summary: {
            minHeight: "45px",
            height: "45px",
        },
        item: {
            display: "flex",
        },
        details: {
            flexDirection: "column",
            paddingLeft: "10px !important",
            paddingRight: "10px !important",
        },
        date: {
            display: "flex",
            paddingLeft: 5,
            paddingRight: 5,
            marginTop: 5,
            marginBottom: 10,
        },
        selectWrapper: {
            padding: "8px !important",
        },
        labelByHand: {
            paddingLeft: 10,
            paddingBottom: 5,
            color: "#808080",
            width: "100%",
        },
    };
};

AdvertisementInformationForm.propTypes = {
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    advertising: {
        associationTypes,
        form: {
            assocType,
            assocLocation,
            assocComments,

            assocInciDateStart,
            assocInciDateEnd,
            assocInciTimeStart,
            assocInciTimeEnd,
            assocTitleCompany,
        },
        searchFormCleared,
    },
}) => ({
    assocType,
    assocLocation,
    assocComments,

    assocInciDateStart,
    assocInciDateEnd,
    assocInciTimeStart,
    assocInciTimeEnd,
    assocTitleCompany,
    associationTypes,
    searchFormCleared,
});

const mapDispatchToProps = (dispatch) => ({
    getAssociationTypes: (url) => dispatch(actions.GET_ASSOCIATION_TYPE.send(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(localStyles)(AdvertisementInformationForm));
